import React, { useEffect, useState } from "react";
import { Grid2, Typography, TextField, Button, Box } from "@mui/material";
import SignUpBg from "../../../Assets/Images/Signup_web.png";
import styles from "./SignUpEmail.module.css";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { callGoogleAuth, generateEmailOtp, setEmailData, setEmailStatus, setPlanData, setRefCodeFromEmail, validateReferralCode } from "../../../Redux/usersSlice";
import Logo from '../../../Assets/Images/logo.svg';
import validator from 'validator';
import applied from '../../../Assets/Images/succ.svg'; // Add this import
import collab from '../../../Assets/Images/collab1.svg';
const SignUpEmail = () => {
  const { loading, userData,source } = useSelector(state => state.user);
  const [email, setEmail] = useState(userData?.email?.toLowerCase() || "");
  const [emailError, setEmailError] = useState("");
  const [referralCode, setReferralCode] = useState(""); // Add this state
  const [isEditing, setIsEditing] = useState(false); // Add this state
  const [invalidRefCodeErr, setInvalidRefCodeErr] = useState(""); // Add this state
  const [isRefApplied, setIsRefApplied] = useState(false);


  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const baseHostName = window.location.hostname;
  let GooggleRedirectUrl = ""
  if (baseHostName.includes("local")) {
    GooggleRedirectUrl = "http://localhost:3000/signupemail"
  }
  if (baseHostName.includes("staging")) {
    GooggleRedirectUrl = "https://kyc-frontend-staging.tradeboss.co/signupemail"
  } else {
    GooggleRedirectUrl = "https://kyc.tradeboss.co/signupemail"
  }

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "kyc_step_viewed",
      step_name: "email_page_viewed",
      page_path: window.location.pathname
    });
  }, []);

  function useDebounce(value, delay = 500) {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
      const timer = setTimeout(() => {
        setDebouncedValue(value);
      }, delay);

      return () => clearTimeout(timer);
    }, [value, delay]);

    return debouncedValue;
  }
  const debouncedReferralCode = useDebounce(referralCode, 600);

  useEffect(() => {
    // do nothing if empty
    if (!debouncedReferralCode) {
      setInvalidRefCodeErr("");
      return;
    }

    handleApplyRefCode(debouncedReferralCode);

  }, [debouncedReferralCode]);




  // Get mobile from userData
  const mobile = userData?.mobile;

  // Redirect if email is already verified
  useEffect(() => {
    if (userData?.steps?.["Email Verify"]?.status) {
      navigate('/signupcongrats');
    }
  }, [userData, navigate]);

  useEffect(() => {
    const refCodeThereInlocalStorage = localStorage.getItem("refCode");
    if (refCodeThereInlocalStorage) {
      setReferralCode(refCodeThereInlocalStorage); // Set referralCode state
      handleApplyRefCode(refCodeThereInlocalStorage)
    } else if (userData?.referral_code) {
      setReferralCode(userData?.referral_code); // Set referralCode state
    }
  }, [userData]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setEmailError("");

    if (!email) {
      setEmailError("Email is required");
      return;
    }

    const isValid = validator.isEmail(email);

    if (!isValid) {
      setEmailError("Please enter a valid email address");
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "kyc_step_viewed",
      step_name: "email_entered",
      page_path: window.location.pathname
    });

    try {
      const response = await dispatch(generateEmailOtp({ mobile, email })).unwrap();
      console.log("res from generateEmailOtp", response)
      // If email is already verified (should be rare as useEffect should catch this)
      if (response.data?.user?.steps?.["Email Verify"]?.status) {
        navigate('/signupcongrats');
      } else {
        if (response?.data?.data?.success) {
          navigate('/signupemailotp');
          dispatch(setEmailData({ email: email }))
        }
        else if (response?.data?.data?.message === "Please provide a valid email") {
          setEmailError("Please provide a valid email")
          console.log("1")
        } else if (response?.data?.data?.message === "An account by this email already exists") {
          setEmailError("An account by this email already exists")
        }
      }
    } catch (error) {
      console.error('Failed to send email OTP:', error);
      setEmailError(error?.data?.data?.message)
    }
  };

  // Add this function after your state declarations
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSubmit(e);
    }
  };

  const handleApplyRefCode = async (value) => {
    if (!value) {
      setIsRefApplied(false);
      setInvalidRefCodeErr("");
      return;
    }
    try {
      const response = await dispatch(
        validateReferralCode({
          mobile: userData.mobile,
          referral_code: value,
        })
      ).unwrap();

      console.log("response from validateReferralCode", response)

      if (response?.data?.data?.message === "Invalid referral code applied") {
        setIsRefApplied(false);
        setIsEditing(false);
        setInvalidRefCodeErr("Invalid Referral code");
      } else {
        dispatch(setPlanData(response?.data?.data?.plan));
        setIsEditing(false);
        setIsRefApplied(true);        // ✅ only here
        setInvalidRefCodeErr("");
      }
    } catch (err) {
      console.error("Failed to apply referral code:", err);
    }
  };

  const handleGoogleLogin =()=>{
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "kyc_step_viewed",
      step_name: "email_google_auth",
      page_path: window.location.pathname
    });
    const clientId = '289268312287-ppth8vvi5qorh1o3sum0crkobrf355n6.apps.googleusercontent.com';
    const redirectUri = GooggleRedirectUrl; // This is in your frontend - give based on environment like https://kyc-frontend-staging.tradeboss.co/signupemail
    const scope = 'openid email'; 
    const responseType = 'code';
    const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=${responseType}&scope=${scope}`;
    window.location.href = authUrl;
  }

  useEffect(() => {
    const DisPatchGoogleData = async () => {
      const code = searchParams.get('code');
      if (code) {
        const mobile = userData?.mobile; // User the phone number of the current client 
        try {
          const response = await dispatch(callGoogleAuth({code:code,mobile:mobile})).unwrap(); //Need to be (backendURL)/otp/google-auth 
          console.log("Google Auth Response:", response?.data?.data);
          console.log("Google Auth Response success:", response?.data?.data?.success);
          if(response?.data?.data?.success){
          const googleEmail = response?.data?.data?.email; // 👈 get email from backend response
          console.log("inside email otp success", googleEmail);

          // update local state
          setEmail(googleEmail);
          
          // update redux
            dispatch(setEmailData({ email: googleEmail }))
            dispatch(setEmailStatus())
          }else{
             setEmailError(response?.data?.data?.message)
          }
        }
        catch (error) { console.error('Error during login', error) }
      }
    };
    DisPatchGoogleData();
  },
    []);

  return (
    <main>
    <Grid2
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundImage: `url(${SignUpBg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        "@media (max-width:600px)": {
          justifyContent: "start"
        }
      }}
    >

      {/* Logo */}
        <img src={source == "cosmos" ? collab : Logo} alt="Logo" className={source == "cosmos" ? styles.twologo : styles.navlogo} />
      {
        source == "cosmos" &&
        <Typography className={styles.txt}>
          Together with Tradeboss, CFG India simplifies Investing in Listed/ Unlisted securities.
        </Typography>
      }
      {/* Headings */}
      <Typography className={styles.heading}>Your Email ID</Typography>
      <Typography className={styles.subHeading}>
        To Personalize your Experience
      </Typography>
      {/* Content Wrapper - maxWidth applies here */}
      <Box
        sx={{
          maxWidth: "420px",
          width: "100%",
          mx: "auto",   // ✅ centers horizontally
          m: 2,
          "@media (max-width: 450px)": {
            width: "90%",   // 📱 shrink on small screens
          },
        }}
      >

        {/* Google Button */}
        <Button
          variant="outlined"
          fullWidth
          sx={{
            height: "48px",
            borderRadius: "25px",
            textTransform: "none",
            borderColor: "#ddd",
            backgroundColor: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "10px",
            fontFamily: "Inter500",
            fontSize: "16px",
            mt: 2,
            boxShadow: "0px 2px 6px rgba(0,0,0,0.05)",
            "&:hover": {
              backgroundColor: "#f9f9f9",
              borderColor: "#ccc",
            },
          }}
          onClick={handleGoogleLogin}
        >
          <Box
            component="img"
            src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
            alt="google"
            sx={{ width: "20px", height: "20px",paddingBottom:"3px" }}
          />
          Continue with Google
        </Button>

        {/* Divider */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            my: 2,
          }}
        >
          <Box sx={{ flex: 1, height: "1px", backgroundColor: "#ddd" }} />
          <Typography sx={{ mx: 2, fontSize: "14px", color: "#777" }}>OR</Typography>
          <Box sx={{ flex: 1, height: "1px", backgroundColor: "#ddd" }} />
        </Box>

        {/* Email Input */}
        <form autoComplete="off">
          <input type="text" name="fakeuser" autoComplete="username" style={{ display: "none" }} />
          <input type="password" name="fakepass" autoComplete="new-password" style={{ display: "none" }} />
        <TextField
          fullWidth
          placeholder="Enter your Email ID"
          value={email}
          onChange={(e) => {
            setEmail(e.target.value.trim()?.toLowerCase());
            setEmailError("");
          }}
          onKeyDown={handleKeyDown}
          // error={!!emailError}
          // helperText={emailError}
          sx={{
            backgroundColor: "#fff",
            borderRadius: "30px",
            "& input": {
              textAlign: "center",
              fontSize: "24px",
              padding: "11px 12px",
              "&::placeholder": {
                fontSize: "20px",
                color: "#000000",
                "@media (max-width: 550px)": {
                  fontSize: "18px",

                },
                "@media (max-width: 550px)": {
                  fontSize: "18px",

                },
              },
              "@media (max-width: 550px)": {
                fontSize: "18px",
                paddingTop: "13px"
              },
              "@media (max-width: 550px)": {
                fontSize: "18px",
                paddingTop: "12px"
              },
            },
            "& .MuiOutlinedInput-root": {
              "& fieldset": { borderRadius: "30px", borderColor: "#ABABAB", },
              "&:hover fieldset": {
                borderColor: "#ABABAB !important", // stop hover change
                borderWidth: "0.5px"
              },
              "&.Mui-focused fieldset": {
                borderColor: "#ABABAB !important", // stop focus change
                borderWidth: "0.5px"
              },
            }
          }}
        />
       </form>
        {emailError && <Typography sx={{ color: "red", mt: 1, fontSize: "0.9rem", textAlign: "center", fontFamily: "Inter400" }}>{emailError}</Typography>}

        {/* Referral Code Section */}
        {/* <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "6px",
            border: "1px dashed #428DFF",
            borderRadius: "8px",
            padding: "8px 14px",
            backgroundColor: "#FFFFFF",
            mt: 2,
            mb: 2,
            mx: "auto",
          }}
        >
          <Typography
            sx={{
              fontSize: "13px",
              fontFamily: "Inter400",
              "@media (max-width:460px)": {
                fontSize: "11px", // 👈 smaller font on small screens
              },
            }}
          >
            Referral code (optional)
          </Typography>

          {isEditing ? (
            <TextField
              value={referralCode}
              onChange={(e) => {
                const value = e.target.value.toUpperCase();
                setReferralCode(value);
                if (value.length === 3 || value.length === 0) {
                  handleApplyRefCode(value);
                  setIsEditing(false);
                }
              }}
              size="small"
              variant="standard"
              sx={{
                pl: 1,
                "& input": {
                  textAlign: "center",
                  fontSize: "14px",
                  fontWeight: 600,
                },
              }}
              InputProps={{ disableUnderline: true }}
              autoFocus
            />
          ) : (
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: "14px",
                color: "#428DFF",
                cursor: "pointer",
                px: 1,
              }}
              onClick={() => setIsEditing(true)}
            >
              {referralCode || "Add"}
            </Typography>
          )}

          {!isEditing && referralCode && (
            <>
              <Typography sx={{ fontSize: "13px", fontWeight: 500 }}>
                applied
              </Typography>
              <Box
                component="img"
                src={applied}
                alt="applied icon"
                sx={{ width: "16px", height: "16px", ml: 1 }}
              />
            </>
          )}
        </Box> */}
        <form autoComplete="off">
          <input type="text" name="fakeuser" autoComplete="username" style={{ display: "none" }} />
          <input type="password" name="fakepass" autoComplete="new-password" style={{ display: "none" }} />
        <TextField
          fullWidth
          placeholder="Enter Referral Code (Optional)"
          value={referralCode}
          autoComplete="off"
          // onChange={(e) => {
          //   const value = e.target.value.toUpperCase().trim();
          //   setReferralCode(value);
          //   setIsEditing(false);
          //   if (value.length === 3 || value.length === 0) {
          //     handleApplyRefCode(value);
          //     setIsEditing(false);
          //   }
          // }}
            onChange={(e) => {
              const value = e.target.value.toUpperCase().trim();
              setReferralCode(value);
              setIsEditing(true);
              setIsRefApplied(false);       // reset while typing
            }}

          onKeyDown={handleKeyDown}
          // error={!!emailError}
          // helperText={emailError}
          sx={{
            backgroundColor: "#fff",
            borderRadius: "30px",
            marginTop:"12px",
            "& input": {
              textAlign: "center",
              fontSize: "24px",
              padding: "11px 12px",
              "&::placeholder": {
                fontSize: "20px",
                color: "#000000",
                "@media (max-width: 550px)": {
                  fontSize: "18px",

                },
                "@media (max-width: 550px)": {
                  fontSize: "18px",

                },
              },
              "@media (max-width: 550px)": {
                fontSize: "18px",
                paddingTop: "13px"
              },
            },
            "& .MuiOutlinedInput-root": {
            "& fieldset": { borderRadius: "30px", borderColor: "#ABABAB", },
            "&:hover fieldset": {
              borderColor: "#ABABAB !important", // stop hover change
              borderWidth: "0.5px"
            },
            "&.Mui-focused fieldset": {
              borderColor: "#ABABAB !important", // stop focus change
              borderWidth: "0.5px"
            },
          }
          }}

          InputProps={{
            endAdornment: (
   !isEditing && isRefApplied && referralCode
 && ( 
                <Box
                  component="img"
                  src={applied}
                  alt="applied icon"
                  sx={{
                    width: "22px", height: "22px", transform: "translateX(-135px)", // default for normal screens
                    "@media (max-width: 430px)": {
                      transform: "translateX(-120px)",
                      width: "20px",
                      height: "20px",
                    },
                    "@media (max-width: 370px)": {
                      transform: "translateX(-110px)", // smallest screens
                      width: "18px",
                      height: "18px",
                    },

                    "@media (max-width: 340px)": {
                      transform: "translateX(-90px)", // smallest screens
                      width: "18px",
                      height: "18px",
                    },
                  }}
                />
              )
            ),
          }}
        />
       </form>
        {/* Referral Code Error */}
        {invalidRefCodeErr && (
          <Typography sx={{ color: "red", mt: 1, fontSize: "0.9rem", textAlign: "center", fontFamily: "Inter400" }}>
            {invalidRefCodeErr}
          </Typography>
        )}

        {/* Next Button */}
        <Button
          fullWidth
          variant="contained"
          sx={{
            marginTop: "20px",
            backgroundColor: "#F3D45E",
            color: "#000",
            fontFamily: "Inter700",
            fontSize: "20px",
            borderRadius: "25px",
            textTransform: "capitalize",
            "&:hover": { backgroundColor: "#FBC02D" },
            height: "52px",
            boxShadow: "none",
             "@media (max-width: 550px)": {
            
              height: "45px"
            },
            "@media (max-width: 420px)": {
            
              height: "45px"
            },
          }}
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? 'Sending...' : 'Next'}
        </Button>

      </Box>
    </Grid2>
    </main>
  );
};

export default SignUpEmail;